import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { isAdmin, isTokenExpired } from "../utilities";

export const canActivate: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  if (isTokenExpired()) {
    return router.createUrlTree(['/login']);
  }
  return true;
};

export const hasNoActiveSession: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);

  if (!isTokenExpired()) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
};

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (isTokenExpired()) {
    return router.createUrlTree(['/login']);
  }

  if (!isAdmin()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
